interface ReviewVideoPlayerProps {
  url: string;
  className?: string;
  onClick?: (event: React.MouseEvent) => void;
}

/** Not muted to buy autoplay: reviews are spoken, and the controls are there if the browser refuses. */
export const ReviewVideoPlayer = ({ url, className, onClick }: ReviewVideoPlayerProps) => (
  // The upload contract carries no caption track, so there is nothing to point a <track> at.
  /* eslint-disable-next-line jsx-a11y/media-has-caption */
  <video src={url} className={className} controls autoPlay loop playsInline onClick={onClick} />
);

export default ReviewVideoPlayer;
